import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import "./styles/fonts.css"
import "./index.css"


render(<App />, document.getElementById("root"));
